export * from './types/audience';
export * from './types/campaigns';
export * from './types/campaigns/originAppType';
export * from './types/campaigns/campaignStatus';
export * from './types/campaigns/campaignFundSource';
export * from './types/campaigns/campaignType';
export * from './types/campaigns/messagingCampaigns';
export * from './types/campaigns/messageDetailPageDetails';
export * from './types/orders';
export * from './types/rewards';
export * from './types/rewards/rewardType';
export * from './types/user';
export * from './types/user/pushNotificationTokenDetails';
export * from './types/company';
export * from './types/company/contractType';
export * from './types/extension';
export * from './types/retailers';
export * from './types/brandclub';
export * from './types/notifications';
export * from './types/notifications/notificationType';
export * from './types/notifications/messagingCampaigns';
export * from './types/notifications/notificationsConstants';
export * from './types/cms';
export * from './types/boolQuery';
// TODO: move to a common utils package shared with backend & frontend
export * from './types/data-utils';
export * from './types/reviews';
export * from './types/checkout';
export * from './types/notifications/userNotificationApiResponse';
export * from './types/retailerSync';
export * from './types/messaging-service';
export * from './types/browser';

export type Awaited<T> = T extends PromiseLike<infer U> ? U : T;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AwaitedReturnType<T extends (...args: any) => any> = Awaited<ReturnType<T>>;
export type AsyncGeneratorType<T> = T extends AsyncGenerator<infer U> ? U : T;
export type ArrayElement<A> = A extends readonly (infer T)[] ? T : never;
